module.exports = __webpack_public_path__ + "media/images/logo-where-blue-light-3021138ed55f40083618753aece06241.svg";